import { Stack, Text } from '@mantine/core';

import { DEFAULT_FILTERS } from '../constants';
import { hasActiveFilters } from '../helpers';
import type { MenuTemplateFilters as Filters, MenuTemplateSummary } from '../types';

import { MenuTemplateCard } from './MenuTemplateCard';
import { NoFilterMatches } from './NoFilterMatches';

type MenuTemplateListProps = {
  templates: MenuTemplateSummary[];
  loading: boolean;
  error: string;
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
  selectedTemplateId: string | null;
  onSelectTemplate: (id: string) => void;
};

export const MenuTemplateList: React.FC<MenuTemplateListProps> = ({
  templates,
  loading,
  error,
  filters,
  onFiltersChange,
  selectedTemplateId,
  onSelectTemplate,
}) => {
  if (error) {
    return (
      <Text c="red" ta="center" py="xl" size="sm" px="xs">
        {error}
      </Text>
    );
  }

  if (templates.length === 0 && !loading) {
    return hasActiveFilters(filters) ? (
      <NoFilterMatches onClear={() => onFiltersChange(DEFAULT_FILTERS)} />
    ) : null;
  }

  return (
    <Stack gap={6} px="xs">
      {templates.map((template) => (
        <MenuTemplateCard
          key={template.id}
          template={template}
          isSelected={template.id === selectedTemplateId}
          onSelect={() => onSelectTemplate(template.id)}
        />
      ))}
    </Stack>
  );
};
